import { PatientGetCollectionByTrialCode, PatientSingleResponse, PatientGetSingleByStudyNumber } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<PatientSingleResponse, PatientSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<PatientSingleResponse, PatientSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePatient = (patientStudyNumber?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return patientStudyNumber ? 
            () => new PatientGetSingleByStudyNumber({ studyNumber: patientStudyNumber }) : 
            undefined;
    }, [patientStudyNumber]);

    return useGet(request, { getData, getError}, configuration);
};

export default usePatient;